import axios from "axios";
import useSWR from "swr";
import getToken from "../helpers/getToken";
import React, { useState } from "react";


const UserProfile = ({ isHome }) => {

  const [userData, setUserData] = useState({
    userName: "elMasKapito",
    name: "Juan",
    lastName: "Pérez",
    email: "juan.perez@example.com",
    age: 25,
    bdate: '1986-10-08',
    avatar: "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png",
    country: "Argentina",
    state: "Tucuman",
    city: "San Miguel de Tucuman",
    address: "Pje Bertres 211",
    zipcode: 4000,
    cellphone: 3854192582,

  });

  const handleSave = (fieldName, value) => {
    setUserData(prevState => ({
      ...prevState,
      [fieldName]: value
    }));
  };


  let backendUrl = process.env.REACT_APP_BACKEND_USER_URL;
  const token = getToken();
  const fetcher = url => axios.get(url, {
    headers: {
      token: token,
    },
  }).then(response => {
    return (response.data.user);
  })

  const { error, isLoading } = useSWR(backendUrl, fetcher)


  if (error) return <div className='MyCVUser'><h5>failed to load your profile, try login again please</h5></div>
  if (isLoading) return <div className='MyCVUser'>loading...</div>

  return (
    <div className="mt-2">
      <div className="homeBlock">
        <img src={userData.avatar} alt="User Avatar" className="rounded-circle" style={{ width: '140px', height: '140px', objectFit: 'cover' }} />
      </div>
      <div className="homeBlock mt-3">
        <h5>basic information</h5>
        <div className="profileFields">name: <EditableField value={userData.name} name="name" onSave={handleSave} /></div>
        <div className="profileFields">lastname: <EditableField value={userData.lastName} name="lastName" onSave={handleSave} /></div>
        <div className="profileFields">user name: <EditableField value={userData.userName} name="userName" onSave={handleSave} /></div>
        <div className="profileFields">birth date: <EditableField value={userData.bdate} name="age" onSave={handleSave} /></div>
        <div className="profileFields">age: <EditableField value={userData.age.toString()} name="age" onSave={handleSave} /></div>
      </div>
      <div className="homeBlock mt-3">
        <h5>contact information</h5>
        <div className="profileFields">email: <EditableField value={userData.email} name="email" onSave={handleSave} /></div>
        <div className="profileFields">cellphone: <EditableField value={userData.cellphone} name="cellphone" onSave={handleSave} /></div>
      </div>
      <div className="homeBlock mt-3">
      <h5>social media</h5>
        <div className="profileFields">linkedin: <EditableField value={userData.ln} name="linkedin" onSave={handleSave} /></div>
        <div className="profileFields">X: <EditableField value={userData.x} name="X" onSave={handleSave} /></div>
        <div className="profileFields">tiktok: <EditableField value={userData.tt} name="tiktok" onSave={handleSave} /></div>
        <div className="profileFields">instagram: <EditableField value={userData.ig} name="instagram" onSave={handleSave} /></div>
      </div>
      <div className="homeBlock mt-3">
        <h5>location information</h5>
        <div className="profileFields">country: <EditableField value={userData.country} name="country" onSave={handleSave} /></div>
        <div className="profileFields">state: <EditableField value={userData.state} name="state" onSave={handleSave} /></div>
        <div className="profileFields">city: <EditableField value={userData.city} name="city" onSave={handleSave} /></div>
        <div className="profileFields">address: <EditableField value={userData.address} name="address" onSave={handleSave} /></div>
        <div className="profileFields">zipcode: <EditableField value={userData.zipcode.toString()} name="zipcode" onSave={handleSave} /></div>
      </div>
    </div >
  );
}

export default UserProfile


function EditableField({ value, name, onSave }) {
  const [isEditing, setIsEditing] = useState(false);
  const [inputValue, setInputValue] = useState(value);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const toggleEdit = () => {
    setIsEditing(!isEditing);
  };

  const handleBlur = () => {
    onSave(name, inputValue);
    toggleEdit();
  };

  return isEditing ? (
    <input
      type="text"
      name={name}
      value={inputValue}
      onChange={handleInputChange}
      onBlur={handleBlur}
      autoFocus
    />
  ) : (
    <span className="mx-3" onClick={toggleEdit}>{value}</span>
  );
}